import { useEffect } from "react";
import { URLSearchParamsInit, useSearchParams } from "react-router-dom";

const useSearchQuery = (filters: any) => {
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    setSearchParams(
      Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => value),
      ) as URLSearchParamsInit,
    );
  }, [filters]);
};

export default useSearchQuery;
